import { createReducer } from '@reduxjs/toolkit'
import { parsedQueryString } from 'hooks/useParsedQueryString'

import { typeInput } from './actions'
import { queryParametersToStakingState } from './hooks'

export interface StakingState {
  readonly typedValue: string
}

const initialState: StakingState = queryParametersToStakingState(parsedQueryString())

export default createReducer<StakingState>(initialState, (builder) =>
  builder.addCase(typeInput, (state, { payload: { typedValue } }) => {
    return {
      ...state,
      typedValue,
    }
  })
)
